(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/views/board-container.js') >= 0) return;  svs.modules.push('/components/numbergames/game/views/board-container.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.numbergames=_svs.numbergames||{};
_svs.numbergames.game=_svs.numbergames.game||{};
_svs.numbergames.game.templates=_svs.numbergames.game.templates||{};
svs.numbergames.game.templates.board_container = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"boardRegion\"></div>\n<div id=\"buttonsRegion\"></div>\n";
},"useData":true});
Handlebars.partials['components-numbergames-game-board_container'] = svs.numbergames.game.templates.board_container;
})(svs, Handlebars);


 })(window);